import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { InnerheaderComponent } from './innerheader/innerheader.component';
import { RouterModule } from '@angular/router'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommaStringToArrayPipe } from '../../comma-string-to-array.pipe';
import { LoginDropdownComponent } from './login-dropdown/login-dropdown.component';
import { TopmenuComponent } from './topmenu/topmenu.component';
import { VideoDetailsComponent } from 'src/app/modals/video-details/video-details.component';
import { LoaderComponent } from './loader/loader.component';
import { NewVideosComponent } from 'src/app/modals/new-videos/new-videos.component';
import { DisclaimerComponent } from 'src/app/modals/disclaimer/disclaimer.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SubscriptionUpdateComponent } from 'src/app/modals/subscription-update/subscription-update.component';
import { SubmitSkillComponent } from 'src/app/modals/submit-skill/submit-skill.component';
import { VideosLockedPopupComponent } from 'src/app/modals/videosLockedPopup/videos-locked-popup.component';
import { ContactDropdownComponent } from './contact-dropdown/contact-dropdown.component';
import { FavouriteVideosComponent } from './favourite-videos/favourite-videos.component';
import { FavouriteSeriesVideosComponent } from './favourite-series-videos/favourite-series-videos.component';
import { FavVideoItemComponent } from './fav-video-item/fav-video-item.component';
import { FavVideoItemAddVideoComponent } from './fav-video-item-add-video/fav-video-item-add-video.component';
import { MyConnectionsComponent } from './my-connections/my-connections.component';
import { PlaylistVideosComponent } from './playlist-videos/playlist-videos.component';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { MessagemodalComponent } from 'src/app/modals/messagemodal/messagemodal.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SeriesheaderComponent } from './seriesheader/seriesheader.component';

@NgModule({
  declarations: [
    HeaderComponent, 
    FooterComponent, 
    InnerheaderComponent,
    SeriesheaderComponent,
    CommaStringToArrayPipe,
    LoginDropdownComponent,
    TopmenuComponent,
    VideoDetailsComponent,
    LoaderComponent,
    NewVideosComponent,
    DisclaimerComponent,
    MessagemodalComponent,
    SubscriptionUpdateComponent,
    SubmitSkillComponent,
    VideosLockedPopupComponent,
    ContactDropdownComponent,
    FavouriteVideosComponent,
    FavouriteSeriesVideosComponent,
    FavVideoItemComponent,
    FavVideoItemAddVideoComponent,
    MyConnectionsComponent,
    PlaylistVideosComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule,
    NgSlimScrollModule,
    SweetAlert2Module.forRoot()
  ], 
  exports: [
    HeaderComponent,
    FooterComponent,
    InnerheaderComponent,
    SeriesheaderComponent,
    CommaStringToArrayPipe,
    VideoDetailsComponent,
    LoaderComponent,
    NewVideosComponent,
    DisclaimerComponent,
    MessagemodalComponent,
    SubscriptionUpdateComponent,
    SubmitSkillComponent,
    VideosLockedPopupComponent,
    FavouriteVideosComponent,
    FavouriteSeriesVideosComponent,
    FavVideoItemComponent,
    FavVideoItemAddVideoComponent,
    MyConnectionsComponent,
    PlaylistVideosComponent
  ]
})
export class SharedModule { }
